import { EncuestaFinal } from "../../dialog/models/encuesta-final";
import { RespuestaFormulario } from "./respuesta-formulario";

export class CabeceraRespuesta{
    fecha_creacion:any;
    respuesta:RespuestaFormulario[]=[];
    //
    id?:string;
    formulario?:EncuestaFinal;
}